export default "__VITE_ASSET__035e4051__"